import { render, staticRenderFns } from "./PrUpload.vue?vue&type=template&id=65710ea6&scoped=true&"
import script from "./PrUpload.vue?vue&type=script&lang=js&"
export * from "./PrUpload.vue?vue&type=script&lang=js&"
import style0 from "./PrUpload.vue?vue&type=style&index=0&id=65710ea6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65710ea6",
  null
  
)

export default component.exports